// Pure display helpers for uploaded-file rows in the vendor questionnaire.
// React-free and unit-tested (the web app has no DOM test runner), same
// discipline as vendorCsv.ts / answerSummary.ts.

// One decimal, dropping a trailing ".0" so we show "1 MB", not "1.0 MB".
function roundOne(n: number): string {
  return (Math.round(n * 10) / 10).toString();
}

// Human-readable file size: 512 -> "512 B", 1536 -> "1.5 KB", 1258291 -> "1.2 MB".
export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${roundOne(kb)} KB`;
  return `${roundOne(kb / 1024)} MB`;
}

// Short uppercase file-kind label for the size line + icon. Extension first,
// then the mime type; unknown -> "FILE".
export function fileKindLabel(fileName: string, mimeType?: string | null): string {
  const ext = fileName.includes('.') ? fileName.split('.').pop()! : '';
  if (ext) return ext.toUpperCase();
  const mt = (mimeType ?? '').toLowerCase();
  if (mt === 'application/pdf') return 'PDF';
  if (mt.startsWith('image/')) return mt.slice('image/'.length).toUpperCase() || 'IMAGE';
  if (mt.includes('word')) return 'DOC';
  if (mt.includes('sheet') || mt.includes('excel')) return 'XLS';
  if (mt.includes('presentation') || mt.includes('powerpoint')) return 'PPT';
  return 'FILE';
}
